'use strict';

angular.module('domain.advancedSearch').controller('AdvancedSearchContact', [
	'AppService',
	'$scope',
	'$stateParams',
	function (AppService, $scope, $stateParams) {
		var AdvancedSearchContact = this;
		var AdvancedSearch = $scope.AdvancedSearch;

		var init = function () {
			AdvancedSearch.changeSearchType(AdvancedSearch.entity.CONTACT, $stateParams.notificationEntityId);

			AdvancedSearch.loaded = true;
		};

		AppService.loadedPromise.then(init);
	}
]);
